/**
 * @Author: v_jppjpeng
 * @Date: 2024-08-01 19:21:21
 * @Explain: 防打扰策略
 */
import { HttpResponse } from '../data.d';
import http from '../http';

const MODEL = '/strategy';

export default {
  // 保存
  onSave(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/save_strategy`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 详情
  getDetails(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/get_strategy`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
